// Source: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques
export const ARIA_ROLES = {
  // Widget roles
  BUTTON: 'button',
  CHECKBOX: 'checkbox',
  GRIDCELL: 'gridcell',
  LINK: 'link',
  MENUITEM: 'menuitem',
  MENUITEMCHECKBOX: 'menuitemcheckbox',
  MENUITEMRADIO: 'menuitemradio',
  OPTION: 'option',
  PROGRESS_BAR: 'progressbar',
  RADIO: 'radio',
  SCROLLBAR: 'scrollbar',
  SEARCHBOX: 'searchbox',
  SLIDER: 'slider',
  SPINBUTTON: 'spinbutton',
  SWITCH: 'switch',
  TAB: 'tab',
  TABPANEL: 'tabpanel',
  TEXTBOX: 'textbox',
  TREEITEM: 'treeitem',

  // Composite roles
  COMBOBOX: 'combobox',
  GRID: 'grid',
  LISTBOX: 'listbox',
  MENU: 'menu',
  MENUBAR: 'menubar',
  RADIOGROUP: 'radiogroup',
  TABLIST: 'tablist',
  TREE: 'tree',
  TREEGRID: 'treegrid',

  // Document structure roles
  APPLICATION: 'application',
  ARTICLE: 'article',
  CELL: 'cell',
  COLUMNHEADER: 'columnheader',
  DEFINITION: 'definition',
  DIRECTORY: 'directory',
  DOCUMENT: 'document',
  FEED: 'feed',
  FIGURE: 'figure',
  GROUP: 'group',
  HEADING: 'heading',
  IMG: 'img',
  LIST: 'list',
  LISTITEM: 'listitem',
  MATH: 'math',
  NONE: 'none',
  NOTE: 'note',
  PRESENTATION: 'presentation',
  ROW: 'row',
  ROWGROUP: 'rowgroup',
  ROWHEADER: 'rowheader',
  SEPARATOR: 'separator',
  TABLE: 'table',
  TERM: 'term',
  TOOLBAR: 'toolbar',
  TOOLTIP: 'tooltip',

  // Landmark roles
  BANNER: 'banner',
  COMPLEMENTARY: 'complementary',
  CONTENTINFO: 'contentinfo',
  FORM: 'form',
  MAIN: 'main',
  NAVIGATION: 'navigation',
  REGION: 'region',
  SEARCH: 'search',

  // Live region roles
  ALERT: 'alert',
  LOG: 'log',
  MARQUEE: 'marquee',
  STATUS: 'status',
  TIMER: 'timer',

  // Window roles
  ALERTDIALOG: 'alertdialog',
  DIALOG: 'dialog',
};

export const ATTRIBUTES = {
  ARIA_ERRORMESSAGE: 'aria-errormessage',
  ARIA_INVALID: 'aria-invalid',
  CLASS: 'class',
  CHECKED: 'checked',
  CUSTOM_ALLOW_CLEAR: 'data-allow-clear', // Used by select2
  CUSTOM_COUNT_CHARACTERS: 'data-count-characters',
  CUSTOM_REQUIRED: 'data-required',
  CUSTOM_TOOLTIP: 'data-tooltip',
  DISABLED: 'disabled',
  FOR: 'for',
  HIDDEN: 'hidden',
  HREF: 'href',
  ID: 'id',
  MIN: 'min',
  MINLENGTH: 'minlength',
  MAX: 'max',
  MAXLENGTH: 'maxlength',
  REQUIRED: 'required',
  ROWS: 'rows',
  SELECTED: 'selected',
  TYPE: 'type',
};

export const DOM_EVENTS = {
  CHANGE: 'change',
  CLICK: 'click',
  FOCUSOUT: 'focusout',
  INPUT: 'input',
  KEYDOWN: 'keydown',
  KEYPRESS: 'keypress',
  LOAD: 'load',
  RESIZE: 'resize',
  SELECT2_SELECT: 'select2:select',
};

export const HTML_ELEMENTS = {
  ANCHOR: 'a',
  BODY: 'body',
  BUTTON: 'button',
  FIELDSET: 'fieldset',
  H2: 'h2',
  HEADER: 'header',
  HTML: 'html',
  INPUT: 'input',
  LABEL: 'label',
  LEGEND: 'legend',
  SELECT: 'select',
  TEXTAREA: 'textarea',
};

export const INPUT_TYPES = {
  CHECKBOX: 'checkbox',
  EMAIL: 'email',
  FILE: 'file',
  NUMBER: 'number',
  RADIO: 'radio',
  SUBMIT: 'submit',
  TEL: 'tel',
  TEXT: 'text',
};
